import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { RefinekbarContainer } from "components/RefinekbarProvider";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";

const queryClient = new QueryClient();

function App() {
  return (
    <BrowserRouter>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <SnackbarProvider maxSnack={3}>
            <RefinekbarContainer />
          </SnackbarProvider>
        </QueryClientProvider>
      </LocalizationProvider>
    </BrowserRouter>
  );
}

export default App;
